module.exports = __webpack_public_path__ + "img/logo-h.97fca00e.png";